export const createColorSchemeSlice = (set) => ({
  colorScheme: 5,
  setColorScheme: (value) => set({ colorScheme: value }),
})
